__turbopack_context__.v({
  "card": "ParagraphBlogLatest-module__KUbWaq__card",
  "cardBody": "ParagraphBlogLatest-module__KUbWaq__cardBody",
  "cardCta": "ParagraphBlogLatest-module__KUbWaq__cardCta",
  "cardExcerpt": "ParagraphBlogLatest-module__KUbWaq__cardExcerpt",
  "cardImg": "ParagraphBlogLatest-module__KUbWaq__cardImg",
  "cardImgPlaceholder": "ParagraphBlogLatest-module__KUbWaq__cardImgPlaceholder",
  "cardMedia": "ParagraphBlogLatest-module__KUbWaq__cardMedia",
  "cardMeta": "ParagraphBlogLatest-module__KUbWaq__cardMeta",
  "cardTitle": "ParagraphBlogLatest-module__KUbWaq__cardTitle",
  "eyebrow": "ParagraphBlogLatest-module__KUbWaq__eyebrow",
  "grid": "ParagraphBlogLatest-module__KUbWaq__grid",
  "header": "ParagraphBlogLatest-module__KUbWaq__header",
  "headerMain": "ParagraphBlogLatest-module__KUbWaq__headerMain",
  "heading": "ParagraphBlogLatest-module__KUbWaq__heading",
  "lead": "ParagraphBlogLatest-module__KUbWaq__lead",
  "root": "ParagraphBlogLatest-module__KUbWaq__root",
  "seeAllBtn": "ParagraphBlogLatest-module__KUbWaq__seeAllBtn",
});
